import React from 'react';
import styles from './authUi.module.css';

function AlertIcon({ tone }) {
  if (tone === 'success') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M8.2 12.4l2.6 2.6 5-5.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.8v5.4M12 16.4v.6" strokeLinecap="round" />
    </svg>
  );
}

/**
 * Inline status message for the auth forms. Errors are announced assertively
 * because they usually mean the reader cannot continue; successes are polite so
 * they do not interrupt a screen reader mid-sentence.
 */
export default function AuthAlert({ tone = 'error', children }) {
  if (!children) return null;

  const isSuccess = tone === 'success';

  return (
    <p
      className={`${styles.alert} ${isSuccess ? styles.alertSuccess : styles.alertError}`}
      role={isSuccess ? 'status' : 'alert'}
    >
      <AlertIcon tone={tone} />
      <span>{children}</span>
    </p>
  );
}
